







import Vue from 'vue'
import Mappa from '../components/report/Mappa.vue'
import Azioni from '../components/report/Azioni.vue'
import {mapActions, mapGetters} from 'vuex'

export default Vue.extend({
    metaInfo: {
        title: 'Report',
        link: [
            {rel: 'apple-touch-icon', sizes: '57x57', href: '/report/favicon/apple-icon-57x57.png'},
            {rel: 'apple-touch-icon', sizes: '60x60', href: '/report/favicon/apple-icon-60x60.png'},
            {rel: 'apple-touch-icon', sizes: '72x72', href: '/report/favicon/apple-icon-72x72.png'},
            {rel: 'apple-touch-icon', sizes: '76x76', href: '/report/favicon/apple-icon-76x76.png'},
            {rel: 'apple-touch-icon', sizes: '114x114', href: '/report/favicon/apple-icon-114x114.png'},
            {rel: 'apple-touch-icon', sizes: '120x120', href: '/report/favicon/apple-icon-120x120.png'},
            {rel: 'apple-touch-icon', sizes: '144x144', href: '/report/favicon/apple-icon-144x144.png'},
            {rel: 'apple-touch-icon', sizes: '152x152', href: '/report/favicon/apple-icon-152x152.png'},
            {rel: 'apple-touch-icon', sizes: '180x180', href: '/report/favicon/apple-icon-180x180.png'},
            {rel: 'icon', type: 'image/png', sizes: '192x192', href: '/report/favicon/android-icon-192x192.png'},
            {rel: 'icon', type: 'image/png', sizes: '32x32', href: '/report/favicon/favicon-32x32.png'},
            {rel: 'icon', type: 'image/png', sizes: '96x96', href: '/report/favicon/favicon-96x96.png'},
            {rel: 'icon', type: 'image/png', sizes: '16x16', href: '/report/favicon/favicon-16x16.png'},
            {rel: 'manifest', href: '/report/favicon/manifest.json'}
        ],
        meta: [
            {name: 'msapplication-TileColor', content: '#ff7f27'},
            {name: 'msapplication-TileImage', content: '/report/favicon/ms-icon-144x144.png'},
            {name: 'theme-color', content: '#ff7f27'}
        ]
    },
    props: {
        comune: String
    },
    components: {
        Mappa, Azioni
    },
    data: () => ({
        messaggioFissoVisibile: false
    }),
    computed: {
        ...mapGetters('user', ['eUnOperatoreGestionaleReport'])
    },
    methods: {
        ...mapActions('reportMappa', ['caricaSegnalazioni', 'caricaStatoSegnalazioni']),
        ...mapActions('modal', ['showModal'])
    },
    created() {
        // carichiamo le cose
        this.caricaSegnalazioni({light: true})
        this.caricaStatoSegnalazioni()
        setTimeout(() => {
            this.messaggioFissoVisibile = true
            setTimeout(() => {
                this.messaggioFissoVisibile = false
            }, 8000)
        }, 3000)
    }
})
